const initialState = {
  fetchMembersPending: false,
  fetchMembersError: null,
  fetchPhasesPending: false,
  fetchPhasesError: null,
  deleteProjectPending: false,
  deleteProjectError: null,
  saveProjectActionPending: false,
  saveProjectActionError: null,
  fetchScopeByProjectPending: false,
  fetchScopeByProjectError: null,
  getNextProjectIdPending: false,
  getNextProjectIdError: null,
  fetchCurrenciesPending: false,
  fetchCurrenciesError: null,
  fetchCloseOutPending: false,
  fetchCloseOutError: null,
  saveCloseOutPending: false,
  saveCloseOutError: null,
  fetchResumePending: false,
  fetchResumeError: null,
  cloneProjectPending: false,
  cloneProjectError: null,
  getCloseOutReportPending: false,
  getCloseOutReportError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/home/redux/initialState.js